module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Hotjar', {
		init: function() {
			this.getOption('optOut') && this.optOut(true);

			this._siteId = this.getOption('siteId');
			this._includeSnippet(this._siteId);

			this.callParent('init', arguments);
		},

		/**
		 * Include snippet for universal ga. Set global flag _gaScriptLoaded after external script loaded.
		 * @return {void}
		 */
		_includeSnippet: function(siteId) {
			if (window.ht || window.doNotTrack === '1') {
				return;
			}

			var _hotjar = this;

			(function(h,o,t,j,a,r){
				h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
				h._hjSettings={hjid:siteId,hjsv:5};
				a=o.getElementsByTagName('head')[0];
				r=o.createElement('script');r.async=1;
				r.onload = _hotjar._handleLoad.bind(_hotjar);
				r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
				a.appendChild(r);
			})(window,document,'//static.hotjar.com/c/hotjar-','.js?sv=');
		},

		_handleLoad: function() {
			this._hj = window.hj;
			this.optOut(this.getOption('optOut'));
		},

		optOut: function(status) {
			window.doNotTrack = status ? '1' : '0';
			if (this._hj) {
				this._hj.optOut = status;
			}
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/hotjar.js
// module id = 307
// module chunks = 2